import React from 'react';
import { Button, Stack } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import ModalTemplate from '../../Container/modal';
import { LoadingButton } from '@mui/lab';

export const DataDownloadConfirmationModal = ({ tagType, isModalOpen, setModalOpen, isDownloadedLoading, onDownloadYesClick, onEmailDownloadYesClick }: any) => {
	return (
		<ModalTemplate
			isOpen={isModalOpen}
			title={`Are you sure, you want to download?`}
			onClose={() => {
				setModalOpen(false);
			}}
		>
			<div className='modal-wrapper-doc'>
				<Stack
					style={{
						alignItems: 'center',
						gap: '12px',
					}}
					direction={'row'}
					spacing={1}
					justifyContent='center'
				>
					<CloudDownload style={{ color: '#3576E5', fontSize: '70px' }} />
				</Stack>

				<Stack style={{ marginTop: '24px' }} direction={'row'} spacing={1} justifyContent='flex-end'>
					{!isDownloadedLoading ? (
						<>
							<Button onClick={() => setModalOpen(false)} variant='outlined'>
								No
							</Button>
							<Button
  								onClick={tagType === 'Mail' ? onDownloadYesClick : tagType === 'Email' ? onEmailDownloadYesClick : undefined}
  								variant="contained"
							>
  								Yes
							</Button>
						</>
					) : (
						<LoadingButton loading loadingIndicator='Downloading...' variant='outlined'>
							Downloading
						</LoadingButton>
					)}
				</Stack>
			</div>
		</ModalTemplate>
	);
};
